import React, { useState } from 'react';
import './faqs.css'; 

function FAQs() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAnswer = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const questionsAndAnswers = [
    {
      question: "How can I book cheap cabs online?",
      answer: "Chavo tours helps you with online cab booking at the best prices, comparatively much lower than the local vendors."
    },
    {
      question: "What are the advantages of Chavo Tours online taxi booking?",
      answer: "With a seamless booking process, customers can quickly choose their pickup and drop-off locations, set their preferences, and confirm their ride, saving time compared to traditional methods. The system offers various options such as one-way or round-trip bookings, allowing customers to tailor their rides according to their specific needs. And also, Transparent pricing helps customers know the cost upfront, eliminating any surprises or hidden fees."
    },
    {
      question: "Why should you book cabs from Chavo Tours?",
      answer: "From Chavo Tours, you can get confirmed cheap cabs of your choice and budget. Expert and verified drivers will be taken care of your ride. With the easy interface of booking with different payment modes available at Ceylon Taxi and finally with no hidden charges, Ceylon Taxi is the best option for online taxi booking."
    },
    {
      question: "What are the best options available for cab booking?",
      answer: "While booking cabs online through Chavo Tours, you can choose the car based on your requirement and preferences. You can book Hatchback like Indica, Swift, Sedan like Toyota Prius, Honda fit shuttle, and SUVs like Honda Vezel, and Toyota CHR."
    },
    {
      question: "What kind of cabs you can book from Chavo Tours?",
      answer: "You can book the following kinds of cabs from Chavo Tours: airport cabs and intercity cabs/outstation cabs. You can book outstation cabs for both one-way transfers & round-trip transfers."
    },
    {
      question: "Is the booking process secure?",
      answer: "Yes, the booking process at Chavo Tours is secure. We use encryption protocols to ensure your personal and payment information is kept private. All transactions are processed securely, and your data is protected from unauthorized access.",
    },
    {
      question: "Can I modify or cancel my cab booking?",
      answer: "Yes, Chavo Tours allows customers to modify or cancel their bookings through the website or app. Modifications or cancellations can be made up to a specified time before the scheduled pickup, depending on the terms of the booking.",
    }
  ];

  return (
    <div className="faq-container">
      <h1 className="faq-title">Frequently Asked Questions</h1>
      <div className="faq-list">
        {questionsAndAnswers.map((item, index) => (
          <div key={index} className="faq-item">
            <div className="faq-question" onClick={() => toggleAnswer(index)}>
              <h3>{item.question}</h3>
              <span className={`toggle-icon ${activeIndex === index ? 'active' : ''}`}>&#9660;</span>
            </div>
            {activeIndex === index && <div className="faq-answer"><p>{item.answer}</p></div>}
          </div>
        ))}
      </div>
    </div>
  );
}

export default FAQs;
